export default {
    disableable: true
}
